export default __webpack_public_path__ + "static/stream-thumbnail-0396ca922b1ce354214b580e6e1720df.png";